export function SectionLabel({ number, label }: { number: string; label: string }) {
  return (
    <div className="section-label" aria-label={`${number} ${label}`}>
      <span className="section-index">{number}</span>
      <span className="section-slash" aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
